import React, { useEffect, useState } from "react";
import { RxCross2 } from "react-icons/rx";
import store from "../../../store/store";
import { editStatus } from "../reducer/orderDetailsSlice";

const StateUpdatePopup = ({ status, orderId }) => {
  const [openPopup, setOpenPopup] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState("");

  const orderStatuses = [
    { id: "Pending", name: "Order Received" },
    { id: "Processing", name: "Processing" },
    { id: "Ready to Ship", name: "Ready to Ship" },
    { id: "Shipped", name: "Shipped" },
    { id: "Delivered", name: "Delivered" },
    { id: "Cancelled", name: "Cancelled" },
  ];

  useEffect(() => {
    setSelectedStatus(status);
  }, [status]);

  const handleOpenPopup = () => {
    setOpenPopup(true);
    document.body.classList.add("modal-open");
  };

  const handleClosePopup = () => {
    setOpenPopup(false);
    document.body.classList.remove("modal-open");
  };

  const handleSave = () => {
    if (!selectedStatus) {
      alert("Please select a status to update.");
      return;
    }

    store.dispatch(editStatus({ orderId, orderStatusId: selectedStatus }));

    handleClosePopup();
  };

  console.log('selectedStatus', selectedStatus);

  return (
    <div className="w-full flex justify-center items-center">
      {status === "Cancelled" ? (
        <button
          className="border-primary3 border h-10 text-sm text-primary3 font-bold rounded-lg mt-5 w-full opacity-50"
          disabled
        >
          Update Status
        </button>
      ) : (
        <button
          onClick={handleOpenPopup}
          className="border-primary3 border py-3 h-10 text-sm text-primary3 font-bold rounded-lg mt-5 w-full flex items-center justify-center text-center"
        >
          Update Status
        </button>
      )}
      {openPopup && (
        <div
          className="fixed inset-0 bg-black bg-opacity-20 backdrop-blur-sm flex justify-center items-center z-[999]"
          onClick={(e) => {
            if (e.target.id === "popupContainer") handleClosePopup();
          }}
          id="popupContainer"
        >
          <div className="bg-white p-5 rounded-lg shadow-lg w-11/12 md:w-1/2 lg:w-1/3">
            <RxCross2
              className="text-xl cursor-pointer absolute top-3 right-3"
              onClick={handleClosePopup}
            />
            <h2 className="text-lg font-semibold mb-3">Update Order Status</h2>
            <p className="text-sm text-gray-600 mb-5">
              Select a status to update the order and click "Save Changes".
            </p>

            <div className="space-y-4">
              {orderStatuses.map(({ id, name }) => (
                <div key={id} className="flex items-center">
                  <input
                    type="radio"
                    id={id}
                    name="orderStatus"
                    value={id}
                    className="accent-primary w-4 h-4 mr-2"
                    checked={selectedStatus === id}
                    onChange={() => setSelectedStatus(id)}
                  />
                  <label htmlFor={id} className="text-sm text-gray-700 cursor-pointer">
                    {name}
                  </label>
                </div>
              ))}
            </div>

            <button
              className="bg-primary3 mt-5 w-full text-sm text-white font-semibold h-10 rounded-lg"
              onClick={handleSave}
            >
              Save Changes
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default StateUpdatePopup;
